// SCAFFOLDED BY g8 — edit directly or run `g8 create --regen` to regenerate.
import React from "react";
import { SectionRenderer, registerServiceSections } from "@repo/features/site";
import { useClientConfig } from "@repo/backend/providers";

registerServiceSections();

// Section layout is hardcoded at scaffold time — edit here or regenerate.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SECTIONS: any[] = [
  {
    "id": "hero-0",
    "type": "hero",
    "variant": "hero-full-bleed",
    "props": {
      "logoUrl": "/logo.webp",
      "logoAlt": "Frontline Auto Care",
      "eyebrow": "Premium Mobile Detailing",
      "headline": "Mobile Detailing",
      "accentPhrase": "That Comes To You",
      "subheadline": "Industrial-grade precision for your driveway. We bring specialized power, water, and expertise to restore your vehicle to a showroom state.",
      "ctaPrimaryLabel": "Book Your Detail",
      "ctaPrimaryTarget": "#services",
      "ctaSecondaryLabel": "Our Process",
      "ctaSecondaryTarget": "#story",
      "imageUrl": "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?q=80&w=2070&auto=format&fit=crop",
      "imageAlt": "Dramatic car detail"
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "services-0",
    "type": "services",
    "variant": "services-tiers-deduped",
    "props": {
      "headline": "Service Tiers",
      "subheadline": "Precision packages tailored to your vehicle's condition. Each tier lists only what it adds — no fine print.",
      "packages": [
        {
          "name": "Quick Detail",
          "tagline": "Essential Maintenance",
          "priceLabel": "$89",
          "icon": "check",
          "features": [
            "Hand wash & microfiber dry",
            "Wheel, tire & arch cleaning",
            "Streak-free glass treatment",
            "Long-lasting tire dressing"
          ],
          "ctaLabel": "Book Now",
          "ctaTarget": "#book",
          "comingSoon": true
        },
        {
          "name": "Full Detail",
          "tagline": "Total Rejuvenation",
          "priceLabel": "$189",
          "icon": "plus",
          "highlight": true,
          "highlightLabel": "Most Popular",
          "features": [
            "Full exterior decontamination",
            "Deep cabin vacuum & air purge",
            "Dash, console & trim dressing",
            "Anti-microbial carpet cleaning",
            "Odor neutralization treatment"
          ],
          "ctaLabel": "Book Now",
          "ctaTarget": "#book",
          "comingSoon": true
        },
        {
          "name": "Premium Detail",
          "tagline": "Elite Protection",
          "priceLabel": "from $399",
          "icon": "zap",
          "features": [
            "Paint correction & clay bar",
            "Industrial bug & tar removal",
            "High-gloss ceramic sealant",
            "Hot water extraction shampoo",
            "Headlight lens restoration"
          ],
          "ctaLabel": "Request Quote",
          "ctaTarget": "#quote",
          "comingSoon": true
        }
      ]
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "before-after-0",
    "type": "gallery",
    "variant": "before-after",
    "props": {
      "headline": "The Results Speak for Themselves",
      "subheadline": "Real vehicles. Real transformations. See what a Frontline detail actually looks like.",
      "pairs": [
        {
          "id": "pair-1",
          "beforeUrl": "/gallery/1_before.jpg",
          "afterUrl": "/gallery/1_after.jpg",
          "beforeAlt": "Heavily soiled fabric seat before detailing",
          "afterAlt": "Restored fabric seat after deep clean",
          "caption": "Fabric seat restoration — years of staining reversed"
        },
        {
          "id": "pair-2",
          "beforeUrl": "/gallery/2_before.jpg",
          "afterUrl": "/gallery/2_after.jpg",
          "beforeAlt": "Dirty vehicle carpet before interior detail",
          "afterAlt": "Clean carpet after hot water extraction",
          "caption": "Interior deep clean — carpet & floor mat extraction"
        },
        {
          "id": "pair-3",
          "beforeUrl": "/gallery/3_before.jpg",
          "afterUrl": "/gallery/3_after.jpg",
          "beforeAlt": "Dull, contaminated blue car exterior before detail",
          "afterAlt": "Mirror-finish blue paint after full exterior detail",
          "caption": "Full exterior detail — paint corrected & ceramic sealed"
        }
      ],
      "ctaLabel": "Book Your Detail",
      "ctaTarget": "#services"
    },
    "animation": {
      "preset": "zoom-out"
    }
  },
  {
    "id": "story-0",
    "type": "story",
    "variant": "story-testimonial",
    "props": {
      "eyebrow": "Automotive Integrity",
      "headline": "Restoring The Standard Of Care",
      "body": "Founded on the principle of uncompromising quality, Frontline Auto Care was born from a passion for automotive excellence. We don't just wash cars; we preserve them using industrial-grade products and refined techniques that have set a new standard for mobile detailing in the region.",
      "imageUrl": "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?q=80&w=1931&auto=format&fit=crop",
      "quote": "The level of detail is unlike anything I've experienced. They didn't just wash my car — they restored its soul right in my driveway.",
      "quoteName": "Laura W.",
      "stat1": "5",
      "stat1Label": "Years Of Master Craftsmanship",
      "stat2": "2K+",
      "stat2Label": "Vehicles Serviced Since Inception"
    },
    "animation": {
      "preset": "none"
    }
  },
  {
    "id": "service-area-0",
    "type": "service-area",
    "variant": "service-area-radius",
    "props": {
      "headline": "We Come To You",
      "subheadline": "Serving Lima and surrounding areas within a 20-mile radius. Book from your driveway — we handle the rest.",
      "address": "Lima, OH",
      "radiusMiles": 20,
      "zoom": 10,
      "markerLabel": "20 mi service area",
      "areasServed": [
        "Lima, OH",
        "Findlay, OH",
        "Bluffton, OH",
        "Wapakoneta, OH",
        "Ada, OH",
        "Delphos, OH",
        "Elida, OH",
        "Spencerville, OH"
      ]
    },
    "animation": {
      "preset": "fade-up"
    }
  }
];

export function HomePage() {
  const config = useClientConfig();
  return (
    <main>
      <SectionRenderer
        sections={SECTIONS}
        clientId="frontline"
        features={config.features}
      />
    </main>
  );
}
